module.exports = require("katex/dist/katex.min.css");